export const appConfiguration = {
  strictMode: Boolean(Number(import.meta.env.VITE_REACT_STRICT_MODE)),
  showExtendedServiceExplanations:
    import.meta.env.VITE_EXTENDED_SERVICE_EXPLANATIONS === 'true',
  login: {
    authority: import.meta.env.VITE_LOGIN_AUTHORITY,
    clientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
    redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
    mock: import.meta.env.VITE_LOGIN_MOCK_LOGIN,
    requiredScopes: import.meta.env.VITE_LOGIN_REQUIRED_SCOPES,
  },
  appSync: {
    url: import.meta.env.VITE_APPSYNC_URL,
    region: import.meta.env.VITE_APPSYNC_REGION,
  },
  simplepay: {
    api: {
      url: import.meta.env.VITE_SIMPLEPAY_API_URL,
    },
  },
  location: {
    api: {
      url: import.meta.env.VITE_LOCATION_API_URL,
    },
  },
  rioTags: {
    api: {
      url: import.meta.env.VITE_RIO_TAGS_API_URL,
    },
  },
  home: {
    url: import.meta.env.VITE_HOME_URL,
  },
  paymentCardProviderLogin: {
    edenred: {
      authority: import.meta.env.VITE_EDENRED_LOGIN_AUTHORITY,
      clientId: import.meta.env.VITE_EDENRED_LOGIN_CLIENT_ID,
      clientSecret: import.meta.env.VITE_EDENRED_LOGIN_CLIENT_SECRET,
      redirectUri: import.meta.env.VITE_EDENRED_LOGIN_REDIRECT_URI,
      scopes: import.meta.env.VITE_EDENRED_LOGIN_SCOPES,
      acr_values: import.meta.env.VITE_EDENRED_LOGIN_ACR_VALUES,
      mock: import.meta.env.VITE_EDENRED_LOGIN_MOCK === 'true',
    },
  },
  supportedPaymentPartnerTypes:
    import.meta.env.VITE_SUPPORTED_PAYMENT_PARTNER_TYPES.split(','),
  supportedServiceTypes: import.meta.env.VITE_SUPPORTED_SERVICE_TYPES.split(
    ',',
  ),
  fleetMonitorWidgetLink: import.meta.env.VITE_FLEET_MONITOR_WIDGET_LINK,
  paymentMethodStatusUpdatePolling: {
    intervalMs: Number(import.meta.env.VITE_PAYMENT_METHOD_POLLING_INTERVAL_MS),
    maxAttempts: Number(
      import.meta.env.VITE_PAYMENT_METHOD_POLLING_MAX_ATTEMPTS,
    ),
  },
};
